import http from "@/utils/http";
// 查询工作台
export const queryConfig = () => http.get(`business/queryConfigNew.htm`)

// 来源查询
export const selectMenuTxtNew = (checkid) => http.get(`business/selectMenuTxtNew.htm?checkid=${checkid}`)

// 查询工作台数量
export const getQueryNum = () => http.get(`business/statsCount/query.htm`)

// 事项来源菜单数据 done,copy,send,draft,todo
export const queryEventByType = (type) => http.get(`business/stats/query.htm?query_type=${type}`)

// 获取数据集
export const queryStatsList = (data) => http.get(`business/stats/query.htm?source_name=${data.source_name?data.source_name:""}&category_name=${data.category_name?data.category_name:""}&item_name=${data.item_name?data.item_name:""}&query_type=${data.query_type?data.query_type:""}&type_name=${data.type_name?data.type_name:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize?data.pageSize:""}`)

// 待办列表
// export const queryReceivedEximplItemList = (data) => http.get(`business/queryReceivedEximplItemList.htm?type_code=${data.type_code}&source_code=${data.source_code}&category_code=${data.category_code}&pageIndex=${data.pageIndex}&item_name=${data.item_name}`)


export const queryReceivedEximplItemList = (data) => http.get(`business/queryReceivedEximplItemList.htm?source_name=${data.source_name?data.source_name:""}&category_name=${data.category_name?data.category_name:""}&query_type=${data.query_type?data.query_type:""}&item_name=${data.item_name?data.item_name:""}&source_code=${data.source_code?data.source_code:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&type_code=${data.type_code?data.type_code:""}`)

// 已办
export const querysendGridEximplListNew = (data) => http.get(`business/querysendGridEximplListNew.htm?type_code=${data.type_code?data.type_code:""}&source_code=${data.source_code?data.source_code:""}&category_code=${data.category_code?data.category_code:""}&state=${data.state?data.state:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&item_name=${data.item_name?data.item_name:""}`)


//我发起的
export const initiatedEximplPublicPage = (data) => http.get(`business/initiatedEximplPublicPage.htm?type_code=${data.type_code?data.type_code:""}&source_code=${data.source_code?data.source_code:""}&category_code=${data.category_code?data.category_code:""}&state=${data.state?data.state:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&item_name=${data.item_name?data.item_name:""}`)

//草稿箱
export const draftsEximplPublicPage = (data) => http.get(`business/draftsEximplPublicPage.htm?type_code=${data.type_code?data.type_code:""}&source_code=${data.source_code?data.source_code:""}&category_code=${data.category_code?data.category_code:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&item_name=${data.item_name?data.item_name:""}`)

//抄送我的
export const querysendMyGridEximplPublicPage = (data) => http.get(`business/querysendMyGridEximplPublicPage.htm?type_code=${data.type_code?data.type_code:""}&source_code=${data.source_code?data.source_code:""}&category_code=${data.category_code?data.category_code:""}&state=${data.state?data.state:""}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&item_name=${data.item_name?data.item_name:""}`)




//点击处理已读、未读
export const updateHandleStatus = (data) => http.get(`updateTodoCenter/updateHandleStatus.htm?item_id=${data.item_id?data.item_id:""}&source_code=${data.source_code?data.source_code:""}`)

